import React, { useState } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { token } from "../../config";
import { useEffect } from "react";
import config from "../../config";
import { json, useNavigate, useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import Spinner from "../../component/loadingbar/Spinner";

const AddSection = () => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  //-------------------------------------------------- state management --------------------------------------
  const [section, setSection] = useState("");
  const [classesnm, setClassesnm] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  //state change handler function
  const handleSectionChange = (e) => {
    setSection(e.target.value);
  };
  const handleClassChangeDropdown = (e) => {
    setSelectedClass(e.target.value);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setSection("");
    setSelectedClass("");

    if (id) {
      navigate("/viewsection");
    }
  };

  //-------------------------------------- get classes for dropdown option --------------------------------------r
  useEffect(() => {
    // Fetch course list
    fetch(`${config.host_url}classes`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setClassesnm(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      });
  }, [token]);

  //--------------------------------------------------- create / add / update section  -------------------------------------------------u--C
  const createSectionBtn = async () => {
    if (!section.trim() || selectedClass === "") {
      triggerNotification("error", "Input fields cannot be empty!!");
      return;
    }
    try {
      await fetch(
        `${config.host_url}section/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            section: section,
            classid: selectedClass,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification("success", "Section created successfully.");
            setSelectedClass("");
            setSection("");
            navigate("/viewsection");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating section:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the section."
      );
    }
  };

  // ---------------------------------------------- get data for update / edit class ----------------------------------------------------r
  useEffect(() => {
    if (id !== undefined) {
      setLoading(true);
      fetch(`${config.host_url}section/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSection(data.data.section);
          setSelectedClass(data.data.classid);
          setLoading(false);
        });
    }
  }, [id]);

  return (
    <>
      <Breadcrumb txt="Manage Section" subpath={["Add Section"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Section</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* Section  */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="cls"
                    id="cls"
                    placeholder="Section "
                    value={section}
                    onChange={handleSectionChange}
                  />
                  <label htmlFor="cls"> Section </label>
                </div>
                {/* Class ID  */}
                <div className="col-md-12 mt-2">
                  <div className="form-floating form-floating-outline mb-4">
                    <select
                      className="form-select mx-auto"
                      id="classdropdown"
                      value={selectedClass}
                      onChange={handleClassChangeDropdown}
                    >
                      <option
                        value=""
                        disabled
                        selected
                        className="text-center"
                      >
                        ---- Select Class ----
                      </option>
                      {classesnm.map((classnm) => (
                        <option key={classnm.classid} value={classnm.classid}>
                          {classnm.class}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="classdropdown">Class</label>
                  </div>
                </div>
                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={createSectionBtn}
                    >
                      {id ? "Update" : "submit"}
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddSection;
